import { render, staticRenderFns } from "./RankingCriteriaDetails.vue?vue&type=template&id=6f9a30f0&"
import script from "./RankingCriteriaDetails.vue?vue&type=script&lang=js&"
export * from "./RankingCriteriaDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports